export const SET_CURRENT_LEAD = 'SET_CURRENT_LEAD';

export function setCurrentLead(lead) {
  return {
    type: SET_CURRENT_LEAD,
    meta: { lead }
  };
}
